/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {useQuery} from '@tanstack/react-query'

import {getUsers, getUsersByCompany, getUserById} from './api'
import {userKeys} from './keys'
import {UserResponse} from './types'

export const useUsers = () => {
  return useQuery<UserResponse[], unknown>({
    queryKey: userKeys.lists(),
    queryFn: () => getUsers(),
  })
}

export const useUsersByCompany = (companyId?: string) => {
  return useQuery<UserResponse[], unknown>({
    queryKey: userKeys.byCompany(companyId || ''),
    queryFn: () => getUsersByCompany(companyId!),
    enabled: !!companyId,
  })
}

export const useUser = (id?: string) => {
  return useQuery<UserResponse, unknown>({
    queryKey: userKeys.detail(id || ''),
    queryFn: () => getUserById(id!),
    enabled: !!id,
  })
}
